import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ComponentNames } from '@core/const';
import { CategoriesMenuNode } from '@main/categories-menu/const';
import { CategoriesMenuService } from '@main/categories-menu/data-access';
import { Step } from '@main/mobile-menu/const';
import { MobileMenuFacade } from '@main/mobile-menu/data-access';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { DeviceService } from '@shared/services';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'sd-mobile-categories-menu',
  templateUrl: './mobile-categories-menu.component.html',
  styleUrls: ['./mobile-categories-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MobileCategoriesMenuComponent implements OnInit {
  @Input() rootNodeId: string;

  componentNames = ComponentNames;
  iconType = CUSTOM_ICON_TYPE;
  node$: Observable<CategoriesMenuNode | undefined>;
  loading$: Observable<boolean>;

  constructor(
    public deviceService: DeviceService,
    private categoriesMenuService: CategoriesMenuService,
    private mobileMenuFacade: MobileMenuFacade,
  ) {}

  ngOnInit(): void {
    this.node$ = this.mobileMenuFacade.getCurrentStep().pipe(
      filter(
        (step) =>
          !!step &&
          !!step.options &&
          (step.componentName === ComponentNames.CategoriesMenu ||
            step.componentName === ComponentNames.MobileMainMenu),
      ),
      switchMap((step: Step) =>
        this.categoriesMenuService.getNode({
          nodeId: step.options?.nodeId as string,
          level: 1,
        }),
      ),
    );
    this.loading$ = this.categoriesMenuService.getLoading();
  }

  goToCategory(headerTitle: string, nodeId: string): void {
    this.mobileMenuFacade.nextStep({
      componentName: ComponentNames.CategoriesMenu,
      headerTitle,
      options: { nodeId },
    });
  }

  openCatalog(): void {
    this.mobileMenuFacade.nextStep({
      componentName: ComponentNames.CategoriesMenu,
      headerTitle: 'Каталог',
      options: { nodeId: this.rootNodeId },
    });
  }
}
